import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatentsService } from '../patents-service';
import { PatentsModel, type PatentInfo } from '../../types';
import { PatentCacheService } from '../patent-cache-service';
import { CurrentStep } from '../../enums';

@injectable()
export class PatentsServiceImpl implements PatentsService {
    constructor(
        @inject(PatentsModel)
        private readonly _model: PatentsModel,
        @inject(PatentCacheService)
        private readonly _patentCacheService: PatentCacheService,
    ) {}

    async loadPatentsByRoundAndStep(roundIndex: number, step: CurrentStep = CurrentStep.Query): Promise<void> {
        console.log(`load patents by roundIndex=${roundIndex}, step=${step}`);

        // 根据步骤从缓存中获取专利数据
        const patents = step === CurrentStep.Query
            ? this._patentCacheService.getPatentData(roundIndex)
            : this._patentCacheService.getPatentData(roundIndex, step);

        // 更新model数据
        this._model.update(() => patents);
    }

    clearPatents(): void {
        this._model.update(() => []);
    }

    getCurrentPatents(): PatentInfo[] {
        return this._model.modelData;
    }

    getPatentsCount(): number {
        return this._model.modelData.length;
    }

}
